import InlineButton, { InlineButtonProps } from "./inline-button";
import React from "react";
import { cn } from "@/lib/utils";
import { getIcon } from "@/lib/get-icon";
import { useWindowSize } from "@/hooks/use-window-size";
import Link from "next/link";

export interface TextCardListedLocationsProps {
  className?: string;
  href?: string;
  title: string;
  items?: { icon: string; text: string; href?: string }[];
  button: InlineButtonProps;
}

const defaultProps = {
  title: "Other Locations",
  href: "#",
};

const TextCardListedLocations: React.FC<TextCardListedLocationsProps> = ({
  className,
  href,
  title,
  items,
  button,
}) => {
  title = title ?? defaultProps.title;
  href = href ?? defaultProps.href;
  const size = useWindowSize();

  return (
    <div
      className={cn(
        "flex w-full flex-col gap-2 rounded-2xl border border-secondary-300 bg-white p-3 md:p-4 lg:gap-4 lg:rounded-[20px] lg:p-6",
        "shadow-[2px_4px_16px_2px_#00414224] md:shadow-[4px_6px_20px_2px_#00414224]",
        className
      )}
    >
      <div className="flex flex-col gap-2 lg:gap-4">
        <div className="flex flex-col gap-4">
          <div
            className={cn(
              "font-montserrat text-subheading-3-500 text-secondary-500 lg:text-subheading-2"
            )}
          >
            {title}
          </div>
          <ul className="grid grid-cols-1 gap-2">
            {items?.map((item, index) => (
              <li key={`${title}-${item.text}-${index}`}>
                {item.href ? (
                  <Link
                    className="flex cursor-pointer flex-row items-start gap-2 font-roboto text-body-1-300 text-neutral-500"
                    href={item.href}
                    prefetch
                  >
                    {getIcon({
                      name: item.icon as "map-pin" | "phone" | "mail" | "clock",
                      className: "min-w-4 h-6",
                      stroke: "#06A6AB",
                    })}
                    <p className="line-clamp-2">{item.text}</p>
                  </Link>
                ) : (
                  <div className="flex flex-row items-start gap-2 font-roboto text-body-1-300 text-neutral-500">
                    {getIcon({
                      name: item.icon as "map-pin" | "phone" | "mail" | "clock",
                      className: "min-w-4 h-6",
                      stroke: "#06A6AB",
                    })}
                    <p className="line-clamp-2">{item.text}</p>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
        {button && (
          <InlineButton
            {...button}
            size={size === "sm" ? "sm" : "md"}
            className={cn(button.className)}
            href={href}
          />
        )}
      </div>
    </div>
  );
};

export default TextCardListedLocations;
